import React from "react";
import ServicePage from "../components/ServicePage";
import bannerimg from "../../media/bannerimg.jpg";
import heroImg from "../../media/accountingmain.png";
import sideImg1 from "../../media/accountingmain1.jpg";
import sideImg2 from "../../media/accountingmain2.png";
import ctaBg from "../../media/servicesidecta.png";
import usePageTitle from "../components/usePageTitle";

const Accounting = () => {
  usePageTitle("Accounting");
  return (
    <ServicePage
      title="Accounting"
      breadcrumb="Accounting"
      bgImage={bannerimg}
      heroImg={heroImg}
      sectionTitle="GAAP-Compliant Accounting Tailored for Strategic Clarity"
      description="At Aspen SR Business Solutions, we provide accurate, timely, and GAAP-compliant accounting services tailored to businesses, nonprofits, and government-funded organizations. From day-to-day bookkeeping to financial statement preparation and general ledger oversight, we ensure your financial records are not only clean but also strategic. We specialize in supporting clients with complex fund structures, multi-source revenues, and compliance requirements—giving you peace of mind and the clarity to make data-driven decisions."
      overviewItems={[
        "Accurate and GAAP-compliant financial reporting.",
        "Comprehensive bookkeeping and ledger oversight.",
        "Support for complex funds and multi-source revenue tracking.",
        "Insightful financials to guide data-driven decision-making.",
      ]}
      featureItems={[
        {
          icon: "bi-lightning-charge",
          title: "Quick solutions",
          text: "Time-saving approaches for strategic goal execution.",
        },
        {
          icon: "bi-bar-chart-line",
          title: "Proven Results",
          text: "Benefit from successful case studies and proven strategies.",
        },
        {
          icon: "bi-person-lines-fill",
          title: "Personalization",
          text: "Focus on tailoring services to meet your exact goals.",
        },
      ]}
      faqList={[
        {
          id: 1,
          question: "What services does your company provide?",
          answer:
            "Our company specializes in a wide range of business and finance services, including but not limited to financial consulting, tax advisory, investment management, and business strategy development.",
        },
        {
          id: 2,
          question: "How can I contact your company?",
          answer:
            "You can reach us via our Contact page or directly call us at (+1) 720-412-7990. We’re available Monday to Friday, 9:00 AM – 6:00 PM.",
        },
        {
          id: 3,
          question: "Is your company licensed and accredited?",
          answer:
            "Yes, Aspen SR Business Solutions is licensed, accredited, and adheres to GAAP and other applicable regulations.",
        },
        {
          id: 4,
          question: "What industries do you specialize in?",
          answer:
            "We specialize in nonprofit organizations, government-funded programs, and small to medium-sized businesses.",
        },
      ]}
      sideImage1={sideImg1}
      sideImage2={sideImg2}
      ctaBg={ctaBg}
      phoneNumber="(+1) 720-412-7990"
    />
  );
};

export default Accounting;
